// extracted by mini-css-extract-plugin
module.exports = {"container":"e_CI","readReviewButton":"e_DI","arrowRight":"e_EI","imageContainer":"e_FI","image":"e_GI","badge":"e_HI","badgeImage":"e_II","content":"e_JI","title":"e_KI"};